import React from "react";
import { Container } from "react-bootstrap";
import { Row, Col, Card } from "react-bootstrap";
// import { FaPhoneAlt, FaEnvelope, FaGlobe } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";

import {
  faPhone,
  faEnvelope,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const BulkOrders = (props) => {
  return (
    <>
    <Helmet>
        <title>Bulk Healthy Cake Orders Chennai – WheatBakes</title>
        <meta
          name="description"
          content="Order bulk natural cakes, whole wheat corporate cakes & eggless desserts. 100% preservative-free, healthy bakery in Chennai."
        />
        <link rel="canonical" href="https://wheatbakes.com/bulkorders" />

      </Helmet>
    
      <div>
        
        <div className="bg-light py-5">
          <Container>
            <div>
              <p className="text-align-center brown-text-color text-bold-600">
                Bulk Orders
              </p>
              <h1 className="text-align-center text-bold-600">
                Wholesome Bakes for Every Business Need
              </h1>
            </div>
            <Row className="align-items-center mt-5">
              {/* LEFT CONTENT */}
              <Col md={6} className="px-5 py-4">
                <h2 className="fw-bold brown-text-color">Tired of Processed Pantry Snacks?</h2>
                <p className="wheatbakes-para-justify">
                  Upgrade to wholesome, guilt-free bakes from Wheat Bakes. Say
                  goodbye to sugary biscuits and preservative-loaded snacks.
                </p>
                <p className="wheatbakes-para-justify">
                  Switch to handcrafted, clean-label cakes, cookies, brownies, and
                  bars made with whole grains, millets, and natural sweeteners
                  like jaggery.
                </p>

                <h2 className="fw-bold mt-4 brown-text-color">Why Choose Wheat Bakes?</h2>
                <ul>
                  <li>100% vegetarian and egg-free</li>
                  <li>
                    Free from white sugar, palm oil, preservatives, and artificial
                    colors
                  </li>
                  <li>Freshly baked using local and traditional ingredients</li>
                </ul>

                <h2 className="fw-bold mt-4 brown-text-color">Perfect For:</h2>
                <ul>
                  <li>Corporate Pantries & Office Gifting</li>
                  <li>Cafés & Coffee Chains</li>
                  <li>Natural & Wellness Stores</li>
                  <li>Premium Retail Counters</li>
                  <li>Event Caterers & Gifting Partners</li>
                </ul>

                <p className="mt-3">
                  Give your customers and team something truly different —
                  indulgent, healthy, and honest.
                </p>
              </Col>

              {/* RIGHT IMAGE */}
              <Col md={6} className="p-0">
                <div className="image-container h-100 text-center">
                  <img
                    src="/images/home/bulkorder.jpg" 
                    alt="Wholesome snacks"
                    className="img-fluid w-75 h-100 object-fit-cover"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="bg-text-image-card">
          <div className="py-5">
            <Container>
              <h2 className="text-center fw-bold mb-5 brown-text-color">Why Partner with Us?</h2>

              <Row className="g-4">
                <Col md={4}>
                  <Card className="h-100 shadow-sm border-0 hover-shadow">
                    <Card.Body>
                      <Card.Title className="fw-bold brown-text-color">
                        Wholesome Product Range
                      </Card.Title>
                      <ul className="mt-3 ps-3">
                        <li>
                          Whole wheat and millet-based cakes, brownies, cookies,
                          and snack bars
                        </li>
                        <li>Naturally sweetened with jaggery—no refined sugar</li>
                        <li>Customizable flavors, sizes, and packaging</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100 shadow-sm border-0 hover-shadow">
                    <Card.Body>
                      <Card.Title className="fw-bold brown-text-color">
                        Consistent Quality, Every Batch
                      </Card.Title>
                      <ul className="mt-3 ps-3">
                        <li>Standardized recipes and strict quality checks</li>
                        <li>Clean-label assurance</li>
                        <li>Trusted by health-conscious brands</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100 shadow-sm border-0 hover-shadow">
                    <Card.Body>
                      <Card.Title className="fw-bold brown-text-color">
                        B2B Friendly Operations
                      </Card.Title>
                      <ul className="mt-3 ps-3">
                        <li>Bulk pricing and low MOQs</li>
                        <li>Reliable delivery across Chennai</li>
                        <li>Dedicated B2B support</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="py-5 bg-light">
            <Container>
              <Row className="align-items-center">
                {/* LEFT IMAGE */}
                <Col md={6} className="p-0">
                  <div className="image-container h-100 w-100 text-center">
                    <img
                      src="/images/product/bulkorder2.jpg" // Replace with your image path
                      alt="Wellness"
                      className="img-fluid w-75 h-100 object-fit-cover"
                    />
                  </div>
                </Col>

                {/* RIGHT CONTENT */}
                <Col md={6} className="px-5 py-4">
                  <h2 className="fw-bold mb-3 brown-text-color">
                    Align with the Wellness Movement
                  </h2>
                  <p className="text-muted mb-4 wheatbakes-para-justify">
                    Join the movement of businesses that care about what they
                    serve — cleaner, healthier, and more conscious alternatives.
                  </p>

                  <h4 className="fw-bold mb-3 brown-text-color">Let’s Collaborate</h4>
                  <p className="mb-2">
                    <FontAwesomeIcon icon={faPhone} /> <strong>Call:</strong> +91
                    79043 09386
                  </p>
                  <p className="mb-2">
                    <FontAwesomeIcon icon={faEnvelope} /> <strong>Email:</strong>{" "}
                    contact@wheatbakes.com
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faGlobe} /> <strong>Website:</strong>{" "}
                    www.wheatbakes.com
                  </p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};
